import { getFirebaseApp } from './firebase';
import config from '../config';

export const addChannelStreamId = async (channelId, streamId, streamer = '', roomId = '') => {
  // TODO: rename roomId to streamId now that we need roomId
  const firebaseApp = await getFirebaseApp();
  firebaseApp
    .firestore()
    .collection('test')
    .doc(channelId)
    .update({ roomId: streamId, streamer: streamer, room: roomId })
    .catch((error) => {
      console.log('addChannelStreamId error', error);
    });
};

export function getApplicationConfig() {
  return fetch(`${config.baseUrl}/config`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json();
  });
}

export async function getHlsUrls() {
  const response = await fetch(`${config.baseUrl}/hls-urls`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    return await response.json();
  } else {
    throw Error('Error while fetching urls');
  }
}
